import { render, staticRenderFns } from "./LiveScore.vue?vue&type=template&id=2fd9f9fd&scoped=true&"
import script from "./LiveScore.vue?vue&type=script&lang=js&"
export * from "./LiveScore.vue?vue&type=script&lang=js&"
import style0 from "./LiveScore.vue?vue&type=style&index=0&id=2fd9f9fd&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd9f9fd",
  null
  
)

export default component.exports